import { dmpCommandFailureContextualizedType, dmpCommandSuccessContextualizedType } from "dmpconnectjsapp-base/actions";
import { formatCloseDMPParams, formatCreateDMPParams }                              from "dmpconnectjsapp-base/actions/config/commandParamsFormatters";
import commands                                                                     from "dmpconnectjsapp-base/actions/config/commands";
import { apiSections, dmpconnectActionConstants }                                   from "dmpconnectjsapp-base/constants";
import { put, take }                                                                from "redux-saga/effects";
import { getAction }                                                                from "../actions";

export const handleManageDMPProcess = function * () {
  while (true) {
    const {
            action, ins, params
          }    = yield take(dmpconnectActionConstants.DMPC_MANAGE_DMP_PROCESS);
    
    let section = "";
    if (action === dmpconnectActionConstants.DMPC_CREATE_DMP_AND_OTP) { // DMPCONNECT-JS V2
      yield put(getAction(
        commands.createDMPAndOtp,
        apiSections.CREATE_DMP_SECTION,
        { ...formatCreateDMPParams(ins, params), i_createOTP: 1 },
        {
          synchronous  : true,
          contextParams: { params },
          subSection   : ins
        }
      ));
      section = apiSections.CREATE_DMP_SECTION;
    } else if (action === dmpconnectActionConstants.DMPC_EDIT_DMP) {
      yield put(getAction(
        commands.updateDmpAdministrativeData,
        apiSections.EDIT_DMP_SECTION,
        params,
        {
          synchronous  : true,
          contextParams: { params },
          subSection   : ins
        }
      ));
      section = apiSections.EDIT_DMP_SECTION;
    } else if (action === dmpconnectActionConstants.DMPC_CLOSE_DMP) {
      yield put(getAction(
        commands.closeDMP,
        apiSections.CLOSE_DMP_SECTION,
        formatCloseDMPParams(ins, params),
        {
          synchronous  : true,
          contextParams: { params },
          subSection   : ins
        }
      ));
      section = apiSections.CLOSE_DMP_SECTION;
    } else if (action === dmpconnectActionConstants.DMPC_REACTIVATE_DMP) {
      yield put(getAction(
        commands.reactivateDMP,
        apiSections.REACTIVATE_DMP_SECTION,
        params,
        {
          synchronous  : true,
          contextParams: { params },
          subSection   : ins
        }
      ));
      section = apiSections.REACTIVATE_DMP_SECTION;
    }
    
    yield take(
      [
        dmpCommandSuccessContextualizedType(section),
        dmpCommandFailureContextualizedType(section)
      ]
    );
  }
};
